import service from '@/plugins/axios'

export function login (data) {
  return service({
    url: '/pub/auth/login',
    method: 'POST',
    data
  })
}

// export function login (data) {
//   return service({
//     url: '/order',
//     method: 'GET',
//     data
//   })
// }

export function logout (data) {
  return service({
    url: '/pub/auth/logout',
    method: 'POST',
    data
  })
}
